export const CARD_STYLE = {
  my: '1rem',
  maxWidth: { md: '82%', lg: '86%', xl: '84%' },
};

export const CARD_CONTENT_STYLE = {
  bgcolor: '#ffffff',
  px: 4,
};

export const AGGREGATE_ROW_STYLE = {
  borderColor: '#e0e0de',
  pr: 1,
  fontFamily: "'Segoe UI Bold', wf_segoe-ui_bold, helvetica, arial, sans-serif",
};

export const ACTION_BUTTON_STYLE = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'start',
  gap: 1,
  flexWrap: 'no-wrap',
};

export const TABLE_CONTAINER_STYLE = {
  backgroundColor: '#fff',
  px: 2,
  pl: 3,
  pt: 3,
  maxHeight: 300,
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  overflow: 'hidden',
};

export const DRILL_DOWN_BUTTON_STYLE = {
  width: 20,
  height: 20,
  borderRadius: '50%',
  backgroundColor: 'black',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
